import { useCallback } from 'react';
import { useToast } from 'commons/hooks';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';

export const usePrintNuvemEnvioLabelToast = () => {
  const t = useNuvemEnvioTranslations();
  const { addToast } = useToast();

  const addErrorToast = useCallback(() => {
    addToast({
      label: t('printNuvemEnvioLabelsStatus.toast.error'),
      appearance: 'danger',
    });
  }, [addToast, t]);

  const addSuccessToast = useCallback(() => {
    addToast({
      label: t('printNuvemEnvioLabelsStatus.toast.success'),
      appearance: 'success',
    });
  }, [addToast, t]);

  return { addErrorToast, addSuccessToast };
};
